import getSharingPermissionListToSearch from '../utils/getSharingPermissionListToSearch';
import getStore from '../store/sharingStore';
import SharingPermissionItemState from '../store/schema/SharingPermissionItemState';
import { mutator } from 'satcheljs';
import { removeCalendarSharingPermission } from '../actions/calendarSharing';
import calendarStrings from 'owa-strings/owa-calendar-strings';
import { format } from 'owa-strings';

export default mutator(removeCalendarSharingPermission, msg => {
    let viewState = getStore().viewState;
    let sharingPermissionItem = msg.sharingPermission;

    if (!viewState && !sharingPermissionItem) {
        return;
    }

    removeSharingPermissionFromArray(
        getSharingPermissionListToSearch(sharingPermissionItem, viewState),
        sharingPermissionItem
    );
    viewState.userActionAriaLabel = format(
        calendarStrings.removePermissionSuccessAriaLabel,
        sharingPermissionItem.EmailAddress.Name
    );
});

// This function finds the sharing permission object based on emailAddress and removed the object.
export let removeSharingPermissionFromArray = function(
    sharingPermissionsArray: Array<SharingPermissionItemState>,
    item: SharingPermissionItemState
) {
    if (!item.EmailAddress || !sharingPermissionsArray) {
        return;
    }

    let foundIndex = -1;
    for (let index = 0; index < sharingPermissionsArray.length; index++) {
        let currentSharingPermission = sharingPermissionsArray[index];
        if (
            currentSharingPermission &&
            currentSharingPermission.EmailAddress &&
            currentSharingPermission.EmailAddress.EmailAddress == item.EmailAddress.EmailAddress
        ) {
            foundIndex = index;
            break;
        }
    }

    if (foundIndex != -1) {
        sharingPermissionsArray.splice(foundIndex, 1);
    }
};
